import { render, staticRenderFns } from "./PlatformSuccessPage.vue?vue&type=template&id=ff480e86&scoped=true"
import script from "./PlatformSuccessPage.vue?vue&type=script&lang=js"
export * from "./PlatformSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformSuccessPage.vue?vue&type=style&index=0&id=ff480e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff480e86",
  null
  
)

export default component.exports